import axios from 'axios'
import { API_ROOT } from '../config'
//axios.defaults.baseURL = API_ROOT
// Vue.prototype.$axios = axios
axios.defaults.withCredentials = true

// axios.interceptors.request.use(
//     config => {
//         if (getCookie('token')) {
//             config.headers.Authorization = 'Bearer ' + getCookie('token').replace(/(^")|("$)/g, '')
//         }
//         return config
//     },
//     error => {
//         return Promise.reject(error)
//     }
// )

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return Promise.reject(error.response)   // 返回接口返回的错误信息
    })
export default axios



// WEBPACK FOOTER //
// ./src/api/config.js